// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';
import { useAppContext } from '../context/AppContext.js';
import ProgressBar from './ProgressBar.js';
import RatingBar from './RatingBar.js';
import IconYes from './icons/IconYes.js';
import IconNo from './icons/IconNo.js';
import { format } from '../utils/format.js';
import { getWords } from '../utils/get-words.js';

const Field = function ({ value, type, translate, variant, color, style }) {
  const { i18n } = useAppContext();
  const words = getWords(i18n.code);

  if (type === 'boolean') {
    if (value) {
      return (
        <div>
          <IconYes size="sm" />
        </div>
      );
    }
    else {
      return (
        <div>
          <IconNo size="sm" />
        </div>
      );
    }
  }
  else {
    switch (variant) {
      case 'framed-text': {
        return (
          <div className={'border rounded d-inline-block' + (color ? (' border-' + color + ' bg-' + color + '-lighter text-' + color) : '')}>
            <div className="px-3 py-1">
              {format(translate ? words[value] : value, type, i18n.dateFormat, i18n.moneySymbol)}
            </div>
          </div>
        );
      }
      case 'progress-bar': {
        return (
          <ProgressBar value={value} color={color} />
        );
      }
      case 'rating-bar': {
        return (
          <RatingBar value={value} color={color} />
        );
      }
      case 'link': {
        if (type === 'string' && /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/.test(value)) {
          return (
            <a href={value}>{value}</a>
          );
        }
        else {
          return (
            <div>{value}</div>
          );
        }
      }
      default: {
        const classNameParts = [];
        if (color) {
          classNameParts.push('text-' + color);
        }
        if (style) {
          classNameParts.push(style);
        }
        if (classNameParts.length > 0) {
          return (
            <div className={classNameParts.join(' ')} style={{ whiteSpace: 'pre-line' }}>
              {format(translate ? words[value] : value, type, i18n.dateFormat, i18n.moneySymbol)}
            </div>
          );
        }
        else {
          return (
            <div style={{ whiteSpace: 'pre-line' }}>
              {format(translate ? words[value] : value, type, i18n.dateFormat, i18n.moneySymbol)}
            </div>
          );
        }
      }
    }
  }
}

export default Field;